<!-- Loading state: hidden img preloads the asset; on error, fallback to upload -->
@if (imageUrl && !imageLoaded && !imageError) {
  <div class="bg-white flex justify-center items-center rounded aspect-square">
    <mat-progress-spinner
      mode="indeterminate"
      [strokeWidth]="5"
      [diameter]="50"
    ></mat-progress-spinner>
    <img
      [src]="imageUrl"
      class="hidden"
      (load)="onImageLoad()"
      (error)="onImageError()"
    />
  </div>
} @else {
  @if (imageUrl && !imageError) {
    <div
      class="relative bg-white flex justify-center items-center asset-container rounded aspect-square"
      [style.width.px]="assetWidth"
    >
      <div class="action-buttons absolute flex flex-col gap-2 items-center">
        <rk-button
          [variant]="'secondary'"
          (buttonClick)="crop.emit(assetKey)"
          [text]="'assets.crop-image' | translate"
          [fullWidth]="true"
        ></rk-button>
        <rk-button
          [variant]="'white'"
          (buttonClick)="replace.emit(assetKey)"
          [text]="'assets.change-image' | translate"
          [fullWidth]="true"
        ></rk-button>
      </div>
      <div class="w-full rounded">
        <!-- dynamic mocks -->
        <rk-asset-dynamic-mock [assetMainColor]="assetMainColor" [assetKey]="assetKey">
        </rk-asset-dynamic-mock>
      </div>
    </div>
  }
}
<!-- Upload field: no image or broken image URL -->
@if (!imageUrl || imageError) {
  <div>
    <rk-image-upload
      (fileSelected)="onRawImageSelected(assetKey, $event)"
      [deleteButton]="false"
      [aspectRatio]="'1/1'"
      [compactLayout]="true"
    ></rk-image-upload>
  </div>
}
